import { camelCase } from 'lodash-es';
import { createSelector } from 'reselect';

import type { Role, UserRoles } from '@iconik-io/shared-lib/src/utils/roles';

import type { AuthUserData } from '../ducks/auth/types';
import type { AppState } from '../store/types';

/**
 * @deprecated Consider using selectUserRoles from shared-lib.
 */
/**
 * UserRoles is generated with one camelCased key per role, but `camelCase` is
 * typed to return a plain string and `Object.fromEntries` always widens keys,
 * so neither end of that mapping survives into the type system. FE-7701 tracks
 * generating the mapping, which would remove this.
 */
const toUserRoles = (entries: [string, boolean][]): UserRoles =>
  // biome-ignore lint/plugin: see above.
  Object.fromEntries(entries) as UserRoles;

const getUserRoles = (userData: AuthUserData, allRoles: Role[]): UserRoles => {
  const isAdmin = Boolean(userData.is_admin || userData.is_super_admin);

  // An admin holds every role; a granted role overrides that for everyone else.
  return toUserRoles([
    ...allRoles.map((role): [string, boolean] => [camelCase(role), isAdmin]),
    ...(userData.roles ?? []).map((role): [string, boolean] => [
      camelCase(role),
      true,
    ]),
  ]);
};

const getUserData = (state: AppState): AuthUserData =>
  state.authReducer.userData;

/**
 * @deprecated Consider using getAllRawRoles from shared-lib.
 */
export const getAllRoles = (state: AppState): Role[] =>
  state.rolesReducer.roles;

/**
 * @deprecated Consider using selectUserRoles from shared-lib.
 */
export const selectUserRoles = createSelector(
  getUserData,
  getAllRoles,
  getUserRoles,
);

export default getUserRoles;
